import React from 'react';
import { Navigate } from 'react-router-dom';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import Forensics from './pages/Forensics';
import SuggestedActions from './pages/SuggestedActions';

export default [
  {
    path: 'forensics',
    element: Forensics,
  },
  {
    path: 'suggested-actions',
    element: SuggestedActions,
  },
  { index: true, element: <Navigate to="forensics" replace /> },
] as Array<EnhancedRouteProps>;
